import React from "react";

const Page1Bottom = () => {
  return (
    <div
      className="
        absolute bottom-0 left-0 w-full
        px-4 sm:px-6 md:px-10
        py-4 sm:py-6 md:py-10
        flex items-end
        text-white
      "
    >
      <div>
        <h2
          className="
            text-sm sm:text-base md:text-2xl
            font-bold
            text-blue-100
            tracking-wide 
          "
        >
          Frontend Developer
        </h2>
      </div>
    </div>
  );
};

export default Page1Bottom;
